<template>
  <div class="page">
    <PageHeader>
      Поиск по транзакциям
    </PageHeader>

    <div v-loading="loading" class="sub_header">
      <div>
        <el-input
          v-model="query"
          placeholder="Поиск по архиву транзакций"
          size="normal"
          clearable
        ></el-input>
        Начиная:
        <el-date-picker
          v-model="filterDateFromLocal"
          type="datetime"
          size="normal"
          placeholder="Начиная"
          :default-time="'00:00:00'"
        >
        </el-date-picker>
        Оканчивая:
        <el-date-picker
          v-model="filterDateToLocal"
          type="datetime"
          size="normal"
          placeholder="Оканчивая"
          :default-time="'23:59:59'"
        >
        </el-date-picker>
        <el-checkbox
          v-model="filterGiveIsCashLocal"
          label="Покупаем кэш?"
        ></el-checkbox>
        <el-checkbox
          v-model="filterGetIsCashLocal"
          label="Продаем кэш?"
        ></el-checkbox>

        <el-select
          v-model="filterGiveValutesLocal"
          placeholder="Покупаем валюты"
          label="Покупаем валюты"
          clearable
          filterable
          multiple
          collapse-tags
        >
          <el-option
            v-for="item in valutes"
            :key="item._id"
            :label="item.title"
            :value="item.bestchangeKey"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="filterGetValutesLocal"
          placeholder="Продаем валюты"
          label="Продаем валюты"
          clearable
          filterable
          multiple
          collapse-tags
        >
          <el-option
            v-for="item in valutes"
            :key="item._id"
            :label="item.title"
            :value="item.bestchangeKey"
          >
          </el-option>
        </el-select>

        <el-button type="primary" size="default" @click="onQuery"
          >Искать</el-button
        >
      </div>
      <div>
        <el-button
          type="primary"
          size="default"
          @click="handleTransactionsWithEmailCSV"
          >Транзакции с емейл CSV</el-button
        >
      </div>
      <div>
        <el-pagination
          @current-change="goToPage"
          @size-change="l => changeLimit({ limit: l })"
          :current-page.sync="pageLocal"
          :page-size="limit"
          layout="sizes, prev, pager, next, jumper"
          :total="totalDocs"
        >
        </el-pagination>
      </div>
      <div>
        <el-input
          type="text"
          :rows="2"
          v-model="exportDescrLocal"
          placeholder="Описание для экспорта"
          :maxlength="-1"
          :show-word-limit="false"
          :autosize="{ minRows: 2, maxRows: 4 }"
        >
        </el-input>

        <router-link
          :to="{
            name: 'TransactionsExport',
            params: {
              filterdata
            }
          }"
        >
          <i class="el-icon-edit edit"></i>
        </router-link>
      </div>
    </div>
    <div v-loading="loading" class="content">
      <div v-for="(transaction, index) in transactions" :key="transaction._id">
        <component
          :is="transactionComponent"
          :key="transaction._id"
          :transaction="transaction"
        ></component>
        <div class="verification-image" v-if="transaction.verificationImage">
          <img
            :src="
              `/uploads/verificationImages/${transaction.verificationImage}`
            "
            alt=""
          />
        </div>
      </div>

      <!-- <div
        class="block"
        :key="transaction._id"
        :class="getStatusCss(transaction.status)"
        v-for="(transaction, index) in transactions"
      >
        <div class="header">
          <div class="title" style="float: right;">
            {{ getStatusText(transaction.status) }}
          </div>
          <div class="title">
            ID: {{ transaction._id }}
            <p><b>IP:</b> {{ transaction.ip }}</p>
            <p><b>Дата:</b> {{ transaction.date }}</p>
            <p><b>Источник:</b> {{ transaction.source }}</p>
          </div>
        </div>

        <div class="content">
          <div class="block-left">
            <h4>Покупаем:</h4>
            <hr />
            <p>
              <b>Валюта:</b>
              {{ transaction.give.valute ? transaction.give.valute.title : "" }}
            </p>
            <p>
              <b>Курс:</b> {{ transaction.give.valute.course }}
              {{ transaction.give.valute.key }}
            </p>
            <p>
              <b>Комиссия:</b>
              {{ 100 - +transaction.give.valute.percentGive * 100 }}%
            </p>
            <p>
              <b>Кошелек:</b>
              {{
                transaction.give.wallet
                  ? transaction.give.wallet.title
                  : "Не известно"
              }}
            </p>
            <div v-if="transaction.give.wallet">
              <div
                v-for="(form, index) in transaction.give.wallet.forms"
                :key="index"
              >
                &nbsp;<b>{{ index + 1 }})</b>
                {{ form ? form.title : "Нет информации" }} -
                {{ form ? form.description : "Нет информации" }}

                <div class="wallet-form-additional-info">
                  {{
                    form
                      ? !form._id &&
                        form.title == "Кошелек" &&
                        form.description &&
                        form.description.length
                        ? "Кошелек Whitebit"
                        : ""
                      : ""
                  }}
                  {{
                    transaction.give.valute.invoiceCard ? "Инвойс Карта" : ""
                  }}
                  {{ transaction.give.valute.invoiceQw ? "Инвойс Qiwi" : "" }}
                  {{
                    transaction.paymentId ? `ID: ${transaction.paymentId}` : ""
                  }}
                  {{
                    transaction.give.valute.invoiceYou ? "Инвойс ЮMoney" : ""
                  }}
                </div>
              </div>
            </div>
            <br />
            <hr />
            <p><b>Формы:</b></p>
            <ul style="margin-left: 20px">
              <li v-for="form in transaction.give.forms" :key="form.key">
                {{ form ? form.title : "" }}: {{ form.value }}
              </li>
            </ul>
          </div>
          <div class="block-right">
            <h4>Продаем:</h4>
            <hr />
            <p>
              <b>Валюта:</b>
              {{ transaction.get.valute ? transaction.get.valute.title : "" }}
            </p>
            <p>
              <b>Курс:</b> {{ transaction.get.valute.course }}
              {{ transaction.get.valute.key }}
            </p>
            <p>
              <b>Комиссия:</b>
              {{ +parseFloat(transaction.get.valute.percentGet) * 100 - 100 }}%
            </p>
            <p>
              <b>Кошелек:</b>
              {{
                transaction.get.wallet
                  ? transaction.get.wallet.title
                  : "Не известно"
              }}
            </p>
            <hr />
            <p><b>Формы:</b></p>
            <ul style="margin-left: 20px">

              <li v-for="form in transaction.get.forms" :key="form.key">
                {{ form ? form.title : "" }}: {{ form.value }}
              </li>
            </ul>
          </div>
          <hr />

          <div class="verification-image" v-if="+transaction.status === 6">
            <img :src="transaction.verificationImage" alt="" />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { queryTransactions, getTransactionsWithEmailCsv } from "@/api";
import { mapState, mapActions } from "vuex";
import OrderTransaction from "../../ui/OrderTransaction.vue";
import OrderTransactionNew from "../../ui/OrderTransactionNew.vue";
import PageHeader from "../../ui/PageHeader.vue";

//
export default {
  components: { PageHeader },
  name: "TrHistory",

  data: () => ({
    query: "",
    trWithEmail: [],
    selectedComponent: "classic",
    transactionComponents: [
      { component: OrderTransaction, title: "Классик", id: "classic" },
      { component: OrderTransactionNew, title: "Модерн", id: "modern" }
    ]
  }),

  methods: {
    ...mapActions("transactionsNew", [
      "getTransactions",
      "goToPage",
      "changeSorting",
      "changeLimit",
      "changeSearchString",
      "changeFilterDateFrom",
      "changeFilterDateTo",
      "changeFilterGiveIsCash",
      "changeFilterGetIsCash",
      "changeFilterGiveValutes",
      "changeFilterGetValutes",
      "performSearch",
      "resetSearch",
      "onlySetExportDescr"
    ]),
    ...mapActions("valutes", ["getValutes"]),
    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В ожидании средств";
        case 1:
          return "В обработке";
        case 2:
          return "Подтверждено";
        case 3:
          return "Отклонено";
        case 4:
          return "Отменено";
        case 5:
          return "В ожидании фото для верификации";
        case 6:
          return "Верификация";
      }
    },

    getStatusCss(status) {
      switch (+status) {
        case 0:
        case 1:
          return { orange: true };
        case 2:
          return { green: true };
        case 3:
        case 4:
          return { red: true };
      }
    },
    async handleTransactionsWithEmailCSV() {
      try {
        const { data } = await getTransactionsWithEmailCsv();
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `transactions_with_email_${this.$dayjs().format(
            "DD_MM_YYYY_HH_mm_ss"
          )}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      }
    },

    async onQuery() {
      // const queryBuilders = [
      //   {
      //     state: "query",
      //     builder: () => {
      //       const q = {
      //         $or: [
      //           {
      //             ip: {
      //               $regex: `.*${this["query"]}.*`,
      //               $options: "i"
      //             }
      //           }
      //           // {
      //           //   email: {
      //           //     $regex: `.*${this["query"]}.*`,
      //           //     $options: "i"
      //           //   }
      //           // }
      //         ]
      //       };
      //       if (this["query"].length === 12 || this["query"].length === 24)
      //         q["$or"].push({ _id: this["query"] });
      //       return q;
      //     }
      //   }
      // ];
      try {
        this.changeSearchString({ searchString: this.query });
        await this.performSearch();
        // const query = {
        //   $and: queryBuilders.map(b => b.builder())
        // };
        // const res = await queryTransactions({
        //   query
        // });
        // this.transactions = res.data.result.docs
        //   ? res.data.result.docs.map(tr => {
        //       return {
        //         ...tr,
        //         give: tr.giveValute,
        //         get: tr.getValute
        //       };
        //     })
        //   : [];
        // console.log(res);
      } catch (error) {
        console.log(error);
      }
    }
  },

  computed: {
    ...mapState("transactionsNew", [
      "transactions",
      "loading",
      "totalPages",
      "totalDocs",
      "page",
      "limit",
      "sort",
      "searchString",
      "filterDateFrom",
      "filterDateTo",
      "filterGiveIsCash",
      "filterGetIsCash",
      "filterGiveValutes",
      "filterGetValutes",
      "isFiltered",
      "filterdata",
      "exportDescr"
    ]),
    ...mapState("valutes", ["valutes"]),
    transactionComponent() {
      return this.transactionComponents.find(
        c => c.id === this.selectedComponent
      )["component"];
    },
    filterDateFromLocal: {
      get() {
        return this.filterDateFrom;
      },
      set(val) {
        this.changeFilterDateFrom({ filterDateFrom: val });
      }
    },
    filterDateToLocal: {
      get() {
        return this.filterDateTo;
      },
      set(val) {
        this.changeFilterDateTo({ filterDateTo: val });
      }
    },
    filterGetIsCashLocal: {
      get() {
        return this.filterGetIsCash;
      },
      set(val) {
        this.changeFilterGetIsCash({ filterGetIsCash: val });
      }
    },
    filterGiveIsCashLocal: {
      get() {
        return this.filterGiveIsCash;
      },
      set(val) {
        this.changeFilterGiveIsCash({ filterGiveIsCash: val });
      }
    },
    filterGiveValutesLocal: {
      get() {
        return this.filterGiveValutes;
      },
      set(val) {
        this.changeFilterGiveValutes({ filterGiveValutes: val });
      }
    },
    filterGetValutesLocal: {
      get() {
        return this.filterGetValutes;
      },
      set(val) {
        this.changeFilterGetValutes({ filterGetValutes: val });
      }
    },
    pageLocal: {
      get() {
        return this.page;
      },
      set(val) {
        this.goToPage({ page: val });
      }
    },
    exportDescrLocal: {
      get() {
        return this.exportDescr;
      },
      set(val) {
        this.onlySetExportDescr({ exportDescr: val });
      }
    }
  },

  async mounted() {
    await this.getTransactions();
    await this.getValutes();
  }
};
</script>

<style scoped>
.green {
  border-left: 5px solid green;
}
.orange {
  border-left: 5px solid orange;
}
.red {
  border-left: 5px solid red;
}

.content {
  overflow: hidden;
}

.block-left,
.block-right {
  float: left;
  padding: 0 5px 10px 5px;
  width: calc(50% - 11px);
}

.block-left {
  border-right: 1px solid #d9d9d9;
}

.buttons {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}

.buttons > button {
  width: 49%;
  display: inline-block;
  cursor: pointer;
}

.buttons > button.ok {
  background-color: green;
  color: #ffffff;
}

.buttons > button.cancel {
  background-color: red;
  color: #ffffff;
}

.verification-image {
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid #aaa;
}
.verification-image img {
  display: block;
  width: 100%;
  height: auto;
}

.wallet-form-additional-info {
  font-size: 15px;
  color: blue;
  font-weight: 600;
}

.sub_header {
  margin-top: 60px;
}

#app > .page > .content {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TransactionsHistory/index.vue